import { adminSummaryQueryKeys as e } from "./adminSummaryQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminSummaryApi as n } from "@maat/api-main";
//#region src/summary/admin/useAdminPlatformCountsQuery.ts
var r = () => t({
	queryKey: e.counts(),
	queryFn: () => n.getCounts()
});
//#endregion
export { r as useAdminPlatformCountsQuery };
